
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.11 12.15a3.26 3.26 0 01-1.167-.194 2.499 2.499 0 01-.838-.523 2.359 2.359 0 01-.523-.79 2.79 2.79 0 01-.17-.971c0-.106.004-.199.012-.28l.05-.23h-.371a.504.504 0 110-1.009h.868l1.701-.923H6.11a.51.51 0 010-1.02h3.912a1.215 1.215 0 00.073-.45c0-.381-.106-.656-.316-.827-.203-.17-.49-.255-.863-.255-.361 0-.69.081-.985.243-.34.189-.794.196-1.044-.102-.202-.242-.202-.602.048-.793a3.007 3.007 0 01.669-.38A3.667 3.667 0 019 3.378c.397 0 .753.061 1.07.183.315.113.582.27.801.473.219.195.385.43.498.705.122.267.183.555.183.863 0 .21-.025.413-.073.607h.4a.51.51 0 110 1.02h-.96l-1.664.924h2.63a.504.504 0 110 1.008H7.944a1.341 1.341 0 00-.073.45c0 .421.114.737.34.948.235.21.56.316.972.316a1.924 1.924 0 001.175-.395c.32-.232.772-.228 1.026.074.209.248.211.617-.039.823a3.646 3.646 0 01-.716.457c-.445.21-.952.316-1.519.316z"}}),_c('path',{attrs:{"d":"M8.665 17.955c-.754-.414-1.225-1.225-1.848-1.815l-1.045-1.144c-1.172-.024-2.353.057-3.52-.065-1.38-.274-2.349-1.672-2.204-3.058 0-3.166-.033-6.335.034-9.5C.312.967 1.712-.109 3.134.056c4.154-.002 8.308-.038 12.461.02C17 .27 18.098 1.648 17.96 3.062c.006 3.196.043 6.393-.02 9.588-.216 1.42-1.62 2.503-3.053 2.341-.997.007-1.993.004-2.99.005-.877.946-1.72 1.926-2.63 2.838a.795.795 0 01-.601.122zm1.347-3.167c.487-.411.815-1.156 1.46-1.314 1.33-.017 2.662.007 3.993-.047 1.058-.233 1.01-1.436.972-2.282-.004-2.816.023-5.632-.018-8.447-.1-1.155-1.402-1.186-2.282-1.115-3.852.008-7.704-.038-11.556.027-1.097.22-1.032 1.458-.997 2.321.005 2.809-.024 5.62.018 8.427.101 1.053 1.266 1.195 2.104 1.1.877.026 1.77-.021 2.64.04.693.475 1.184 1.199 1.776 1.794l.713.778c.395-.425.785-.855 1.177-1.282z"}})])
          )
        }
      }
    